exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.delay-card{position:relative;width:100%;height:82px;border-bottom:1px solid #8b8b8b;display:flex}.delay-card:hover{cursor:pointer}.delay-card.fade-in{opacity:1;animation-name:fadeInOpacity;animation-iteration-count:1;animation-timing-function:ease-in;animation-duration:1s}.delay-card .delay-type-icon-background{width:48px;height:48px;margin-left:25px;margin-top:17px;border-radius:4px;background-color:#184e78;justify-content:center;align-items:center}.delay-card .delay-type-icon-background .delay-type-icon{padding:8px;width:30px;height:32px}.delay-card .delay-description{display:flex;flex-direction:column;margin-left:20px;height:100%;width:calc(100% - 140px);justify-content:center}.delay-card .delay-description .delay-name{display:flex;overflow-y:hidden;color:#333;font-family:Open Sans,sans-serif;font-size:16px;font-weight:600;line-height:18px;max-height:36px}.delay-card .delay-description .delay-date-time{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:14px;line-height:18px}.delay-card .delay-arrow{position:absolute;top:33px;right:24px;height:16px;width:16px;background-repeat:no-repeat;background-size:9px 16px;background-position:100%;background-image:url(" + require("../../../assets/images/task-navigate.svg") + ")}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/DelaysContainer/DelayCard/DelayCard.scss
// module id = 1549
// module chunks = 0